export interface INewApiLogin {
  userName: string;
  pictureUrl: string;
  userId: number;
  email: string;
  token: string;
}
